webpackJsonp([173463008800483],{

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(106);
	
	__webpack_require__(349);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalysesBanner = function AnalysesBanner(_ref) {
	  var title = _ref.title,
	      analysesList = _ref.analysesList,
	      analysesListIcon = _ref.analysesListIcon;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'analyses-banner' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'center',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'analyses-list' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          analysesList.map(function (analyse, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: analyse, className: 'col' },
	              _react2.default.createElement(
	                'center',
	                null,
	                _react2.default.createElement(_index.AnalysesIcon, { icon: analysesListIcon[i], title: analyse })
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	AnalysesBanner.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  analysesList: _propTypes2.default.array.isRequired,
	  analysesListIcon: _propTypes2.default.array.isRequired
	};
	
	exports.default = AnalysesBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  position: 'relative',
	  marginTop: 50,
	  width: 100,
	  height: 100,
	  background: '#1EAAE5',
	  transform: 'rotate(-45deg)'
	};
	
	var AnalysesIcon = function AnalysesIcon(_ref) {
	  var _ref2;
	
	  var icon = _ref.icon,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: style },
	      _react2.default.createElement(
	        'div',
	        {
	          style: (_ref2 = {
	            position: 'absolute',
	            width: 63,
	            left: 0,
	            top: 18
	          }, _ref2['left'] = 17, _ref2.transform = 'rotate(45deg)', _ref2.color = 'white', _ref2)
	        },
	        _react2.default.createElement(
	          'i',
	          {
	            className: 'material-icons',
	            style: {
	              fontSize: 60
	            }
	          },
	          icon
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          marginTop: 50,
	          fontFamily: 'Roboto',
	          fontSize: 20,
	          fontWeight: 'bold'
	        }
	      },
	      title
	    )
	  );
	};
	
	AnalysesIcon.propTypes = {
	  icon: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = AnalysesIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ui = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MecaBanner = function MecaBanner(_ref) {
	  var title = _ref.title,
	      dataList = _ref.dataList;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'container',
	      style: {
	        marginTop: 15,
	        marginBottom: 15
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          marginBottom: 30
	        }
	      },
	      _react2.default.createElement(
	        'center',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          title
	        )
	      )
	    ),
	    _react2.default.createElement(_ui.NavCard, { dataList: dataList })
	  );
	};
	
	MecaBanner.propTypes = {
	  title: _propTypes2.default.string,
	  dataList: _propTypes2.default.array
	};
	
	exports.default = MecaBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(350);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VenteBanner = function VenteBanner(_ref) {
	  var title = _ref.title,
	      image = _ref.image,
	      content = _ref.content;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'services-vente',
	      style: { backgroundColor: '#F5F5F5', paddingTop: 15, paddingBottom: 30 }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'center',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { paddingTop: 10 }, className: 'services-vente-content row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-6 mb-3' },
	          _react2.default.createElement(_gatsbyImage2.default, { alt: image.title, sizes: image.sizes })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-6' },
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: content } })
	        )
	      )
	    )
	  );
	};
	
	VenteBanner.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired,
	  content: _propTypes2.default.string.isRequired
	};
	
	exports.default = VenteBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AnalysesIcon = exports.AnalysesBanner = exports.MecaBanner = exports.VenteBanner = exports.HeaderBanner = undefined;
	
	var _HeaderBanner = __webpack_require__(65);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	var _VenteBanner = __webpack_require__(227);
	
	var _VenteBanner2 = _interopRequireDefault(_VenteBanner);
	
	var _MecaBanner = __webpack_require__(226);
	
	var _MecaBanner2 = _interopRequireDefault(_MecaBanner);
	
	var _AnalysesBanner = __webpack_require__(224);
	
	var _AnalysesBanner2 = _interopRequireDefault(_AnalysesBanner);
	
	var _AnalysesIcon = __webpack_require__(225);
	
	var _AnalysesIcon2 = _interopRequireDefault(_AnalysesIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.HeaderBanner = _HeaderBanner2.default;
	exports.VenteBanner = _VenteBanner2.default;
	exports.MecaBanner = _MecaBanner2.default;
	exports.AnalysesBanner = _AnalysesBanner2.default;
	exports.AnalysesIcon = _AnalysesIcon2.default;

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _services = __webpack_require__(106);
	
	var _ContactUs = __webpack_require__(50);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services(_ref) {
	  var data = _ref.data;
	
	  var mecaList = data.mecaBannerNav;
	  var dataList = [{
	    id: mecaList[0],
	    content: data.mecaBannerDepannageContent.childMarkdownRemark.html,
	    image: data.mecaBannerDepannageImage
	  }, {
	    id: mecaList[1],
	    content: data.mecaBannerGarantieContent.childMarkdownRemark.html,
	    image: data.mecaBannerGarantieImage
	  }, {
	    id: mecaList[2],
	    content: data.mecaBannerMaintenanceContent.childMarkdownRemark.html,
	    image: data.mecaBannerMaintenanceImage
	  }, {
	    id: mecaList[3],
	    content: data.mecaBannerAmeliorationContent.childMarkdownRemark.html,
	    image: data.mecaBannerAmeliorationImage
	  }, {
	    id: mecaList[4],
	    content: data.mecaBannerRevisionContent.childMarkdownRemark.html,
	    image: data.mecaBannerRevisionImage
	  }, {
	    id: mecaList[5],
	    content: data.mecaBannerProtectionContent.childMarkdownRemark.html,
	    image: data.mecaBannerProtectionImage
	  }];
	
	  var hreflang = data.node_locale === 'fr' ? 'en' : 'fr';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'services' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('html', { lang: data.node_locale }),
	      _react2.default.createElement(
	        'title',
	        null,
	        'Offshore Services - ' + data.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: data.metaDescription }),
	      _react2.default.createElement('link', {
	        rel: 'alternate',
	        hreflang: hreflang,
	        href: 'https://www.offshoreservices.fr/' + hreflang + '/services/'
	      })
	    ),
	    _react2.default.createElement(_services.HeaderBanner, { title: data.title, image: data.headerImage }),
	    _react2.default.createElement(_services.VenteBanner, {
	      title: data.venteBannerTitle,
	      image: data.venteBannerImage,
	      content: data.venteBannerContent.childMarkdownRemark.html
	    }),
	    _react2.default.createElement(_services.MecaBanner, { title: data.mecaBannerTitle, dataList: dataList }),
	    _react2.default.createElement(_services.AnalysesBanner, {
	      title: data.analysesBannerTitle,
	      analysesList: data.analysesBannerList,
	      analysesListIcon: data.analysesBannerListIcon
	    }),
	    _react2.default.createElement(_ContactUs2.default, { locale: data.node_locale })
	  );
	};
	
	exports.default = Services;
	module.exports = exports['default'];

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.enServicesQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Services = __webpack_require__(232);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesPage = function ServicesPage(_ref) {
	  var data = _ref.data;
	
	  var servicesData = data.allContentfulServicesPage.edges[0].node;
	  return _react2.default.createElement(_Services2.default, { data: servicesData });
	};
	
	ServicesPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = ServicesPage;
	var enServicesQuery = exports.enServicesQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-en-js-0311c421704eb7f4a8e8.js